"use client";

import { useState } from "react";
import { X } from "lucide-react";
import Container from "@/app/components/ui/container";
import type { AlertT } from "@/app/types/alerts";

type AlertCardContentPropsT = {
  alert: AlertT;
};

/**
 * Alert Card Content Component
 * Displays alert as a card with bg-muted styling
 */
export default function AlertCardContent({ alert }: AlertCardContentPropsT) {
  const [isAlertOpen, setIsAlertOpen] = useState(true);
  const [isAlertClosing, setIsAlertClosing] = useState(false);

  const handleAlertClose = () => {
    setIsAlertClosing(true);
    setTimeout(() => {
      setIsAlertOpen(false);
    }, 300);
  };

  const hasContent = Boolean(alert.title || alert.description);

  if (!hasContent || !isAlertOpen) {
    return null;
  }

  return (
    <div
      className={`transition-all duration-300 ease-in-out ${
        isAlertClosing
          ? "max-h-0 overflow-hidden opacity-0"
          : "max-h-96 opacity-100"
      }`}
    >
      <Container size="default" className="mt-8 py-4 sm:mt-14">
        <div className="bg-muted relative rounded-lg border p-4">
          <button
            type="button"
            onClick={handleAlertClose}
            className="text-muted-foreground hover:text-foreground absolute top-4 right-4 flex-shrink-0 rounded-sm p-1 transition-colors"
            aria-label="Alert schließen"
          >
            <X className="h-4 w-4" />
          </button>
          <span className="text-xl font-bold">🔔 Hinweis</span>
          <div className="mt-4">
            {alert.title && (
              <h3 className="text-foreground mb-2 text-base font-bold">
                {alert.title}
              </h3>
            )}
            {alert.description && (
              <p className="text-muted-foreground text-sm whitespace-pre-wrap">
                {alert.description}
              </p>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
}
